import { createContext, useContext } from 'react'

import type { AnalyticsFilterForm } from 'modules/enps/hooks/useAnalyticsMultiFilters'
import type EnpsForm from 'modules/enps/store/models/Form'

export interface EnpsFormContextProps {
  analyticsFilter: AnalyticsFilterForm | undefined
  form: EnpsForm | null | undefined
  loadingForm: boolean
  refreshForm: boolean
  setRefreshForm: (param: boolean) => void
  resultsFilter: AnalyticsFilterForm | undefined
  setAnalyticsFilter: (analyticsFilter: AnalyticsFilterForm) => void
  setResultsFilter: (resultsFilter: AnalyticsFilterForm) => void
}

export const EnpsFormContext = createContext<EnpsFormContextProps | null>(null)

export const useEnpsFormContext = (): EnpsFormContextProps => {
  const context = useContext(EnpsFormContext)
  if (context === null) {
    throw new Error('useEnpsFormContext must be used within an EnpsFormContext.Provider')
  }
  return context
}
